import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'
import { ContentToggleIcon } from '@myxplor/icons'
import { FormButton, FormDisplayErrors } from '@myxplor/forms'
import { withToggle } from '../show-hide'
import './error-display-fatal.css'

const defaultDescription = (
  <Fragment>
    This may have been caused by your internet connection (or WiFi) being interrupted. It is likely
    that this is a temporary problem so try refreshing this page or try again in a few minutes.
  </Fragment>
)

const ErrorDisplayFatal = ({
  title = 'There was an error loading content',
  description,
  errors,
  open,
  toggle,
  center = false,
}) => (
    <div className="errorDisplayFatal--wrapper">
      <Heading small compact sup="Error">
        {title}
      </Heading>

      <FormButton onClick={toggle} center={center}>
        <ContentToggleIcon left open={open} /> {open ? 'Close' : 'View'} more information
    </FormButton>
      {open && <HelpMessage errors={errors}>{description}</HelpMessage>}
    </div>
  )

const HelpMessage = ({ errors = {}, children = defaultDescription }) => (
  <div className="errorDisplayFatal--help">
    <FormDisplayErrors
      errors={[<h4 key="err1">This is what the error was…</h4>, errors.summary || 'Unknown error']}
    />
    {children}
  </div>
)

export default withToggle(ErrorDisplayFatal)



// WEBPACK FOOTER //
// ./src/ui/error-display-fatal/index.jsx